module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_408905526_L-small-a708196b3b1150a093289f6e37c618a6.jpg";